<template>

  <t-page>


    <t-page-form card :submit-text="currentPage.singularTitle"
                 title="Transmissão SP Obras"
                 command="view" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" go-back-to="custom-consorciolmm-checklist-spobras"
                 :busy="!pageFormIsLoaded">


      <template #default>


        <t-form-card title="Localização" class="mt-2">

          <b-row>

            <t-input cols="8" fixed v-model="form.enterprise" label="Escola"/>

            <t-input cols="4" fixed v-model="form.enterpriseZipcode" label="CEP"/>

          </b-row>

          <b-row>

            <t-input fixed v-model="form.enterpriseAddressFull" cols="6" label="Endereço"/>

            <t-input fixed v-model="form.enterpriseNeighborhood" cols="6" label="Bairro"/>

          </b-row>

          <b-button
              :to="{path: '/checklist/'+form.checklistNumber}"
              class="mt-2"
              variant="outline-primary" target="_blank">
            <b-icon-box-arrow-up-right class="mr-2"/>
            Detalhar Inspeção de Origem
          </b-button>

        </t-form-card>

        <t-form-card title="Relatórios de Atividades" class="mt-2">

          <b-row class="mb-2">

            <b-button
                :to="{path:'/'+activity.path}"
                v-for="activity in activities" :key="activity.checklistActivityId"
                variant="outline-primary" class="mr-2" target="_blank">
              <b-icon-box-arrow-up-right class="mr-2"/>
              {{ activity.name }}
            </b-button>

          </b-row>


        </t-form-card>


        <t-form-card :title="item.division + ' - ' + item.environment" class="mb-3"
                     v-for="item in environments.filter(a => a.finishDate !== undefined && a.qtyEvidenceFile > 0)"
                     :key="item.checklistEnvironmentId">


          <ChecklistEnvironmentEvidenceFile type-image
                                            :business-evidence-file-required-fields="form.businessEvidenceFileRequiredFields"
                                            :foreign-key="item.checklistEnvironmentId"/>

        </t-form-card>

        <t-form-card title="Informações Transmissão" class="mt-2">

          <b-row>

            <t-input cols="6" fixed v-model="form.issueDate" date label="Data Inspeção"/>

            <t-input cols="6" fixed v-model="form.checklistStatusLastChangeDate" datetime label="Data Transmissão"/>

          </b-row>


          <div v-if="form.checklistStatusLastChangeDate === undefined">


            <b-button
                :href="'https://custom.onlaine.com.br/integration/custom/consorciolmm/spobras.asp?install=Y&token='+token+'&checklistId='+form.checklistId"
                variant="primary" target="_blank">
              <b-icon-box-arrow-up-right class="mr-2"/>
              Acessar Módulo Transmissão
            </b-button>

            <t-button class="ml-3" secondary @click="transmitirSPObras">
              Marcar manualmente como transmitido
            </t-button>

          </div>

          <t-button v-else @click="estornarSPObras">Estornar Transmissão</t-button>

        </t-form-card>


      </template>


    </t-page-form>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ChecklistEnvironmentEvidenceFile from "@/views/modules/checklist/Checklist/ChecklistEnvironmentEvidenceFile";
import ui from "@/assets/scripts/ui";
import ChecklistModelActivityService from "@/services/modules/checklist/ChecklistModelActivity.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ConsorcioLmmSPObrasForm',
  components: {ChecklistEnvironmentEvidenceFile},
  data() {
    return {
      path: "checklist", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "checklistId",
      enableGeneralFields: false,
      form: {},
      activities: [],
      environments: [],
      error: {//Campos que podem receber retorno de erro do backend

      },
      token: "",
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      environmentsFields: [
        {key: "environment", label: "Ambiente"},
        {key: "field_706", label: "Último Avanço %", formatter: "number"},
        {key: "field_707", label: "Avanço Físico %", formatter: "number"},
      ]
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },

    async mountedContinued() {

      const account = await this.$store.getters.getAccountUser

      this.token = account.token

      await crudGeneral.getAll('checklist/environment', 1, 'checklistId=' + this.form.checklistId)
          .then(response => {

            this.environments = response.data

            for (let item of this.environments) {

              if (!this.objValid(item.finishDate)) {
                item.class = 'bg-light'
              }

            }

          })
          .catch(error => {
            console.log('Erro externo: ' + error)
          });

      await ChecklistModelActivityService.getList(this.form.checklistId)
          .then((list) => this.activities = list)
          .catch(error => this.responseError(error))

      this.pageFormIsLoaded = true

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async transmitirSPObras() {

      ui.msgConfirm(this, 'Confirmação', 'Tem certeza que deseja marcar a inspeção como transmitida manualmente para SP Obras?', async () => {

        const checklistStatusUpdate = {
          checklistId: this.form.checklistId,
          checklistStatusId: 2, /*Transmitido SP Obras*/
          note: "",
          clearLastChangeDate: false,
        }

        await crudGeneral.update(this.path + "/updateStatus", checklistStatusUpdate).then(
            () => {
              ui.toast(this, "Informação", "Transmissão marcada com sucesso!")
              this.setRedirect('custom/checklist/spobras', this.form.checklistId, 'view', 0, "", true)
            }
        ).catch(error => this.responseError(error))

      })



    },
    async estornarSPObras() {

      ui.msgConfirm(this, 'Confirmação', 'Tem certeza que deseja estornar a inspeção como transmitida para SP Obras?', async () => {

        const checklistStatusUpdate = {
          checklistId: this.form.checklistId,
          checklistStatusId: 1, /*Pendente SP Obras*/
          note: "",
          clearLastChangeDate: true,
        }

        await crudGeneral.update(this.path + "/updateStatus", checklistStatusUpdate).then(
            () => {
              ui.toast(this, "Informação", "Transmissão desmarcada com sucesso!")
              ui.reload()
            }
        ).catch(error => this.responseError(error))

      })


    },
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },

}
</script>